import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BrandM, BrandS, LabelM } from '@sorare/core/src/atoms/typography';
import { FOOTBALL_PLAY_PRO_ONBOARDING_SELECT_COMPETITION } from '@sorare/core/src/constants/__generated__/routes';
import { glossary } from '@sorare/core/src/lib/glossary';

import cardStack from './assets/card-stack.png';
import cards from './assets/cards.png';

const Root = styled(Vertical).attrs({ gap: 4 })`
  border-radius: var(--double-unit);
  background: linear-gradient(
      to bottom,
      var(--c-black),
      rgba(var(--c-rgb-black), 0.75)
    ),
    var(--c-white);
`;
const VerticalWithPadding = styled(Vertical)`
  padding: var(--double-and-a-half-unit) var(--double-and-a-half-unit) 0
    var(--double-and-a-half-unit);
`;
const Footer = styled(Horizontal).attrs({ gap: 0, center: true })`
  position: relative;
  background-color: rgba(var(--c-rgb-common), 0.2);
  border-radius: 0 0 var(--double-unit) var(--double-unit);
  max-height: calc(6 * var(--unit));
`;
const CardStack = styled.img`
  align-self: flex-end;
`;

export const BackToCommon = () => {
  return (
    <Root>
      <Vertical gap={2}>
        <VerticalWithPadding gap={1.5}>
          <BrandS color="var(--c-nd-600)">
            <FormattedMessage
              id="BackToCommon.title"
              defaultMessage="Not ready yet?"
            />
          </BrandS>
          <LabelM>
            <FormattedMessage
              id="BackToCommon.subtitle"
              defaultMessage="Play Academy for free to learn the basics of Sorare."
            />
          </LabelM>
        </VerticalWithPadding>
        <VerticalWithPadding gap={0} center>
          <img width={300} src={cards} alt="Cards" />
          <Button
            color="tertiary"
            size="medium"
            to={FOOTBALL_PLAY_PRO_ONBOARDING_SELECT_COMPETITION}
          >
            <FormattedMessage {...glossary.playNow} />
          </Button>
        </VerticalWithPadding>
      </Vertical>
      <Footer>
        <CardStack src={cardStack} alt="" />
        <BrandM>
          <FormattedMessage id="BackToCommon.footer" defaultMessage="Academy" />
        </BrandM>
      </Footer>
    </Root>
  );
};
